import { publicRequest } from "../config/requestMethods";
import { changePasswordFailure } from "../redux/reduxSlice/authRedux";
import { changePasswordSuccess } from "../redux/reduxSlice/authRedux";
import {
  loginFailure,
  loginStart,
  loginSuccess,
  signUpFailure,
  signUpSuccess,
} from "../redux/reduxSlice/authRedux";
import {
  getChemLessonFailure,
  getChemLessonStart,
  getChemLessonSuccess,
  getPhyLessonFailure,
  getPhyLessonStart,
  getPhyLessonSuccess,
} from "../redux/reduxSlice/lessonRedux";
import {
  getpaymentsFailure,
  getpaymentsSuccess,
} from "../redux/reduxSlice/paymentRedux";
import {
  getPdfLessonFailure,
  getPdfLessonStart,
  getPdfLessonSuccess,
} from "../redux/reduxSlice/pdfRedux";
import {
  getStudyPackFailure,
  getStudyPackStart,
  getStudyPackSuccess,
} from "../redux/reduxSlice/studyPackRedux";
import {
  getVideoLessonFailure,
  getVideoLessonStart,
  getVideoLessonSuccess,
  updateWatchTimeSuccess,
} from "../redux/reduxSlice/videoRedux";

export const signUp = async (user, dispatch) => {
  const res = await publicRequest.post(`user/signup`, user);
  if (res?.data.signature) {
    dispatch(signUpSuccess());
    return res.data;
  } else {
    throw new Error("Signup Error");
  }
};

export const signIn = async (user, dispatch) => {
  dispatch(loginStart());
  const res = await publicRequest.post(`user/login`, user);
  //if (res?.data?.student?.paid && res?.data.signature) {
  if (res?.data.signature) {
    sessionStorage.setItem("signature", res.data.signature);
    sessionStorage.setItem("user", JSON.stringify(res.data.student));
    if (res?.data?.payment?.length > 0) {
      sessionStorage.setItem("payment", JSON.stringify(res?.data?.payment[0]));
    }
    dispatch(loginSuccess(res.data));

    return res.data;
  } else {
    dispatch(loginFailure());
    throw new Error("Login Error");
  }
};

export const ForgetPassword = async (user, dispatch) => {
  const res = await publicRequest.post(`user/forget-password`, user);

  if (res?.status === 200) {
    dispatch(changePasswordSuccess());
    return res.data;
  } else {
    dispatch(changePasswordFailure());
    throw new Error("Password Change Error");
  }
};

export const getChemLesson = async (dispatch) => {
  dispatch(getChemLessonStart());
  try {
    const res = await publicRequest.get(`user/chemistry-lessons`);

    dispatch(getChemLessonSuccess(res.data));
  } catch (error) {
    dispatch(getChemLessonFailure());
  }
};
export const getPhyLesson = async (dispatch) => {
  try {
    dispatch(getPhyLessonStart());
    const res = await publicRequest.get(`user/physics-lessons`);
    dispatch(getPhyLessonSuccess(res.data));
  } catch (error) {
    dispatch(getPhyLessonFailure());
  }
};

export const getVideoByLessonId = async (id, userId, dispatch) => {
  try {
    dispatch(getVideoLessonStart());
    const res = await publicRequest.get(`user/get-vedios/${id}/${userId}`);
    dispatch(getVideoLessonSuccess(res.data));
  } catch (error) {
    dispatch(getVideoLessonFailure());
    throw new Error("Error");
  }
};

export const getPdfByLessonId = async (id, distpatch) => {
  try {
    distpatch(getPdfLessonStart());
    const res = await publicRequest.get(`user/get-pdf/${id}`);
    distpatch(getPdfLessonSuccess(res.data));
    return res.data;
  } catch (error) {
    distpatch(getPdfLessonFailure());
    throw new Error("Error");
  }
};

export const sendEmail = async (email, classId) => {
  try {
    const res = await publicRequest.post(`user/send-email`, { email, classId });
    return res.data;
  } catch (error) {
    throw new Error("Error");
  }
};

export const getWatchTime = async (videoId, userId) => {
  const res = await publicRequest.get(
    `user/get-watch-time/${videoId}/${userId}`
  );
  if (res.data) {
    return res.data;
  } else {
    throw new Error("Error");
  }
};

export const createOrupdateWatchTime = async (dispatch, data) => {
  const res = await publicRequest.post(
    `user/create-or-update-watch-time`,
    data
  );
  if (res.data) {
    dispatch(updateWatchTimeSuccess(res.data));
    return res.data;
  } else {
    throw new Error("Error");
  }
};

export const getPayments = async (id, dispatch) => {
  try {
    const res = await publicRequest.get(`user/get-payment/${id}`);
    dispatch(getpaymentsSuccess(res.data));
  } catch (error) {
    dispatch(getpaymentsFailure());
  }
};

export const createPayment = async (data) => {
  try {
    const res = await publicRequest.post(`user/add-payment`, data);
    if (res.data) {
      sessionStorage.setItem("payment", JSON.stringify(res.data.payment));
    }
    return res.data;
  } catch (error) {
    throw new Error("Error");
  }
};

export const studyPackUserSignUp = async (data) => {
  const res = await publicRequest.post(`studypackuser/signup`, data);
  if (res?.data?.email) {
    return res.data;
  } else {
    throw new Error("Error");
  }
};

export const studyPackUserSignIn = async (data, dispatch) => {
  const res = await publicRequest.post(`studypackuser/login`, data);

  if (res?.data?.email) {
    sessionStorage.setItem("studyPackUser", JSON.stringify(res.data));
    return res.data;
  } else {
    throw new Error("Error");
  }
};

export const getStudyPacks = async (data, dispatch) => {
  try {
    const queryParams = new URLSearchParams(data).toString();
    dispatch(getStudyPackStart());
    const res = await publicRequest.get(
      `studypackuser/get-study-packs?${queryParams}`
    );

    if (res?.data) {
      dispatch(getStudyPackSuccess(res.data));
    }
  } catch (error) {
    dispatch(getStudyPackFailure());
    throw new Error("Error");
  }
};

export const getMyStudyPacks = async (data, dispatch) => {
  try {
    const queryParams = new URLSearchParams(data).toString();
    dispatch(getStudyPackStart());
    const res = await publicRequest.get(
      `studypackuser/get-mystudy-packs?${queryParams}`
    );

    if (res?.data) {
      dispatch(getStudyPackSuccess(res.data));
    }
  } catch (error) {
    dispatch(getStudyPackFailure());
    throw new Error("Error");
  }
};

export const buyStudyPack = async (data) => {
  try {
    const res = await publicRequest.post(
      `studypackuser/add-study-packs-payment`,
      data
    );
    if (res?.data) {
      return res.data;
    } else {
      throw new Error("Error");
    }
  } catch (error) {
    throw new Error("Error");
  }
};

export const logout = async () => {
  sessionStorage.clear();
};
